// import UUID from 'uuid-js'
import md5 from 'js-md5'

// 签名
let appKey = 'D8A4A2624D3CED206DFDBA019A53DB72'
let secret = 'B1DB31F046AEEBC14049037C268A9FFD'
// const appSecurity = 'appSecurity'

// config 为拦击请求的config
export const createSign = (config) => {
    let params = []
    if (config.method === 'get') {
        params = [].concat(handleUrl(config.url), handleParams(config.params))
    } else {
        params = [].concat(handleUrl(config.url), handleData(config))
    }
    // 去重复项
    params = [...new Set(params)]
    // 根据首字母排序
    params = params.sort((a, b) => {
        return (a + '').localeCompare(b + '')
    })
    // 拼装成字符串
    // params = params.join('').replace(/\=/g, '') + appKey
    params = params.join('&') + '&secret=' + secret
    // console.log(params, 'sadasdasdas')
    // md5加密
    let sign = md5(params).toUpperCase()
    // 将参数放入contentType
    config.headers = {
        ...config.headers,
        'X-Api-Key':appKey,
        sign,
        'Content-Type': 'application/json'
    }
    return config
}

// 解析Url后面的参数
function handleUrl(url){
    let index = url.indexOf('?')
    if(index !== -1){
        let str = url.substring(index + 1)
        return str.split('&').filter(item => {
            return item.split('=')[1]
        })
    }else{
        return []
    }
}

// 解析params对象
function handleParams(params){
    if(Object.keys(params).length !== 0){
        let res = []
        for (const key in params) {
            if (params[key]) {
                res.push(key + '=' + params[key])
            }
        }
        return res
    }else{
        return []
    }
}
// 解析data对象
function handleData(config){
    const data = config.data
    const contentType = config.headers['Content-Type']
    let res = []
    if(config.method !== 'get'){
        if(contentType === 'application/x-www-form-urlencoded'){
            res = data.split('&').filter(item => {
                return item.split('=')[1]
            })
        }
        if(contentType === 'application/json'){
            res.push('params=' + JSON.stringify(data))
        }
    }
    return res
}